Directives.MemberListingDirective = function MemberListingDirective() {

    // @ngInject
    function MemberListingDirectiveControllerFunc($scope, $injector, UsersManager, UIUtils, ConversationService) {

        var self = this;
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'MemberListingDirectiveControllerFunc';
        this.UsersManager = UsersManager;
        this.ConversationService = ConversationService;
        this.UIUtils = UIUtils;

        this.showMoreNotes = this.member.notes && this.member.notes.length > 80;
        this.showVendorLinks = this.UsersManager.showVendorLinks(this.member);
        this.allowMessaging = this.showVendorLinks;

        self.openPrivateConversation = function openPrivateConversation(){

            self.ConversationService.startConversationTwoUsers(self.UsersManager.getCurrUser(),self.member);

        };

        self.getVendorType = function  getVendorType(){
            if (this.member.company.company_type_name === 'Other'){
                if (this.member.company.other_company_type && this.member.company.other_company_type !== ''){
                    return this.member.company.other_company_type;
                }
            }
            return this.member.company.company_type_name;
        };

    }

    var MemberListingDirectiveController = Class(Controllers.BaseController, {
        constructor: MemberListingDirectiveControllerFunc
    });

    return {
        scope: {
            deleteAction: '=',
            editAction: '=',
            member: '=',
            showRemove: '=',
            showEdit: '=',
            onRemove: '&?',
            onEdit: '&?',
            contactNotes: '='
        },
        templateUrl: 'angular/app/modules/core/features/workspace/member_listing/member_listing_directive_template.html',
        controller: MemberListingDirectiveController,
        controllerAs: 'memberListingVm',
        bindToController: true
    };
};